import React from 'react';
import { faBug } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const BugIcon = () => (
  <Icon tooltip="Cleanup" iconObj={faBug} />
);

export default BugIcon;